
const registration = {
  step_one: {
    label: 'Business details',
    title: 'Let’s register your business',
    content: 'Tell us about your business to get started',
    cta: 'Continue'
  },
  step_two: {
    label: 'Contact person',
    title: 'Contact Person',
    content: 'Tell us who we should contact for your merchant account and onboarding updates',
    cta: 'Continue'
  },
  step_three: {
    label: 'Create password',
    title: 'Create a strong password',
    content: 'A strong password keeps your merchant dashboard and funds secure',
    cta: 'Create password',
    consent: {
      1: 'By clicking Sign up, I agree that I have read and accepted the ',
      2: 'Terms of Use',
      3: ' and ',
      4: 'Privacy Policy'
    },
  },
  email_verify: {
    title: 'Verify your business email',
    content: 'Enter the code we sent to',
    error: 'Incorrect code. Try again',
    resend: 'Didn\'t receive code?',
    resend_cta: 'Resend code',
    cta: 'Confirm email'
  },
  forgot_password: {
    title: 'Forgot your password?',
    content: 'Enter your ReachAfrika business email below and we\'ll send you a link to reset.',
    email_label: 'Email',
    cta: 'Send reset link',
    check_title: 'Check your email',
    check_content: 'Check the email address',
    check_content_end: 'for instructions to reset your password',
    resend: 'Resend email'
  },
  login: {
    title: 'Sign in to ReachAfrika Merchant',
    error: 'Incorrect email or password. Try again'
  },
  field: {
    bname: 'Business name (Legal name)',
    bname_placeholder: 'Eg. GOIL Filling Station LTD',
    bmail: 'Business email',
    bmail_placeholder: 'example@company.com',
    fname: 'First name',
    fname_placeholder: 'Enter first name',
    lname: 'Last name',
    lname_placeholder: 'Enter last name',
    email: 'Email address',
    work_email: 'Work email',
    country: 'Country',
    country_placeholder: 'Select Country',
    category: 'Industry / Category',
    category_placeholder: 'Select industry',
    phone: 'Phone number',
    job_title: 'Job title / role',
    job_title_placeholder: 'Enter job title',
    password: 'Password',
    confirm_password: 'Confirm Password',
    confirm_password_placeholder: 'Re-enter password',
    password_confirmation: 'Repeat password',
  },
  password: 'Password',
  signup: 'Signup',
  success: 'New merchant created successfully',
  forgot: 'Forgot password?',
  signin: 'Sign in',
  register: 'Don\'t have an account?',
  registered: 'Already have an account?',
  welcome: '',
  tc: 'Terms & Conditions'
};

export default registration;
